import {
  getStorage as getStorageRC,
  removeStorage as removeStorageRC,
  setStorage as setStorageRC,
} from '@picsart/growth-rc/services/browserStorage';
import type { setStorageType } from './types';

const setStorage = ({ name, value, isTemp = false }: setStorageType): boolean => {
  setStorageRC(name, value, !isTemp);
  return true;
};

const removeStorage = ({ name, isTemp = false }: setStorageType): boolean => {
  removeStorageRC(name, !isTemp);
  return true;
};

const getStorage = ({ name, isTemp = false }: setStorageType): string | null => {
  return getStorageRC(name, !isTemp);
};

export { getStorage, removeStorage, setStorage };
